'use client';

import clsx from 'clsx';
import s from './styles.module.scss';
import { ButtonHTMLAttributes, ReactNode } from 'react';

type FancyButtonProps = {
    normalSvg: string;
    hoverSvg: string;
    width?: number | string;
    height?: number | string;
    fit?: string;
    children?: ReactNode;
    className?: string;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export default function FancyButton({
    normalSvg,
    hoverSvg,
    width = 260,
    height = 72,
    fit = 'fill', // 'contain' | 'cover' | 'fill'
    children,
    className,
    ...props
}: FancyButtonProps & { fit?: 'contain' | 'cover' | 'fill' }) {
    const bgSize = fit === 'fill' ? '100% 100%' : fit === 'cover' ? 'cover' : 'contain';

    return (
        <div
            className={clsx(s.borderWrapper, className)}
            style={
                {
                    '--btn-w': typeof width === 'number' ? `${width}px` : width,
                    '--btn-h': typeof height === 'number' ? `${height}px` : height,
                    '--normal-svg': `url(${normalSvg})`,
                    '--hover-svg': `url(${hoverSvg})`,
                    '--bg-size': bgSize,
                } as React.CSSProperties
            }
        >
            <button className={s.fancyBtn} {...props}>
                {children}
            </button>
        </div>
    );
}
